// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings-toggle-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0;
  gap: 29px;
  cursor: pointer;
  user-select: none;
  font-family: 'roboto', sans-serif;
  min-height: 27px;
}

.settings-toggle-container.no-icon {
  gap: 0;
}

.settings-toggle-icon {
  width: 20px;
  margin-right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.settings-toggle-icon i {
  font-size: 20px;
  color: #000;
}

.settings-toggle-icon img {
  width: 20px;
  height: 20px;
}

.settings-toggle-text {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.settings-toggle-label {
  font-size: 16px;
  line-height: 16px;
  font-weight: normal;
  color: rgb(51, 51, 51);
}

.settings-toggle-description {
  font-size: 12px;
  color: #666;
  line-height: 1.4;
}

/* Toggle Switch */
.settings-toggle-switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 18px;
  flex-shrink: 0;
  cursor: pointer;
}

.settings-toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.settings-toggle-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.38);
  transition: 0.3s;
  border-radius: 26px;
}

.settings-toggle-slider:before {
  position: absolute;
  content: "";
  height: 24px;
  width: 24px;
  left: 0;
  bottom: -3px;
  background-color: white;
  transition: 0.3s;
  border-radius: 50%;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
  transition: 450ms
  cubic-bezier(0.23, 1, 0.32, 1);
}

.settings-toggle-switch input:checked + .settings-toggle-slider {
  background-color: color-mix(in srgb, var(--netsfere-red) 50%, transparent);
}

.settings-toggle-switch input:checked + .settings-toggle-slider:before {
  transform: translateX(26px);
  background-color: rgb(222, 72, 88);
}

.settings-toggle-switch input:disabled + .settings-toggle-slider {
  opacity: 0.5;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/components/SettingsModal/SettingsToggle.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,UAAU;EACV,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,qCAAqC;EACrC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,OAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,4EAA4E;EAC5E;gCAC8B;AAChC;;AAEA;EACE,0EAA0E;AAC5E;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":[".settings-toggle-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0;\n  gap: 29px;\n  cursor: pointer;\n  user-select: none;\n  font-family: 'roboto', sans-serif;\n  min-height: 27px;\n}\n\n.settings-toggle-container.no-icon {\n  gap: 0;\n}\n\n.settings-toggle-icon {\n  width: 20px;\n  margin-right: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.settings-toggle-icon i {\n  font-size: 20px;\n  color: #000;\n}\n\n.settings-toggle-icon img {\n  width: 20px;\n  height: 20px;\n}\n\n.settings-toggle-text {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.settings-toggle-label {\n  font-size: 16px;\n  line-height: 16px;\n  font-weight: normal;\n  color: rgb(51, 51, 51);\n}\n\n.settings-toggle-description {\n  font-size: 12px;\n  color: #666;\n  line-height: 1.4;\n}\n\n/* Toggle Switch */\n.settings-toggle-switch {\n  position: relative;\n  display: inline-block;\n  width: 50px;\n  height: 18px;\n  flex-shrink: 0;\n  cursor: pointer;\n}\n\n.settings-toggle-switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.settings-toggle-slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.38);\n  transition: 0.3s;\n  border-radius: 26px;\n}\n\n.settings-toggle-slider:before {\n  position: absolute;\n  content: \"\";\n  height: 24px;\n  width: 24px;\n  left: 0;\n  bottom: -3px;\n  background-color: white;\n  transition: 0.3s;\n  border-radius: 50%;\n  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;\n  transition: 450ms\n  cubic-bezier(0.23, 1, 0.32, 1);\n}\n\n.settings-toggle-switch input:checked + .settings-toggle-slider {\n  background-color: color-mix(in srgb, var(--netsfere-red) 50%, transparent);\n}\n\n.settings-toggle-switch input:checked + .settings-toggle-slider:before {\n  transform: translateX(26px);\n  background-color: rgb(222, 72, 88);\n}\n\n.settings-toggle-switch input:disabled + .settings-toggle-slider {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
